export default {
  presenter: 'jakubco',
  title: 'V učiteľských montérkach',
  subtitle:
    'Čo všetko sa dá dosiahnuť s deťmi a komunitou v úplne odlišných podmienkach',
  text: `
Každý z nás má svoju cestu života. Ja som si na svoju životnú cestu obliekol „učiteľské montérky“.
Dva roky som slúžil ako učiteľ v Škole pre mimoriadne nadané deti a gymnázium v BA. Dva roky som učil deti v rómskej osade v Stráňach pod Tatrami v rámci programu Teach for Slovakia. Víziou TFS je, aby každé dieťa malo možnosť získať vzdelanie, ktoré mu umožní v živote uspieť. Do TFS som sa zapojil z dvoch dôvodov. Jeden je osobný. Rodičia vštepovali hodnoty, akými sú vzdelanie, úcta k životu, pomoc iným. Cítim zodpovednosť za dary, ktoré som od života dostal, preto som sa rozhodol zo seba odovzdať viac a venovať dva roky svojho života deťom, ktoré sú podľa majoritnej spoločnosti, už pri narodení takpovediac odsúdené na neúspech v živote.
Som presvedčený, že niet lepšej univerzity pre formovanie môjho srdca, charakteru a líderských schopností, ako miesto, na ktorom som slúžil.
Druhým dôvodom je profesionálna angažovanosť za zlepšenie vzdelávania na Slovensku.Mám veľkú túžbu byť pri zmene vzdelávacieho systému , aby vzdelávanie bolo funkčné, moderné a dávalo šancu každému.
  `,
}



// WEBPACK FOOTER //
// ./src/content/devdata/data/presentations/p10_v_ucitelskych_monterkach.js